import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { delay, share, takeUntil } from 'rxjs/operators';
import { MoghimAccountingProxy } from '@core/proxies/MoghimAccountingProxy';
import { HttpClient } from '@angular/common/http';
import { BaseComponent } from './BaseComponent';

@Injectable()
export class LayoutService extends BaseComponent {

    protected layoutSize$ = new Subject();
    public headerBtn$ = new BehaviorSubject<boolean>(false);
    public accountingTotal$ = new BehaviorSubject<number>(0);

    private proxy = new MoghimAccountingProxy(this.http);

    constructor(private http: HttpClient) {
        super();
    }

    changeLayoutSize() {
        this.layoutSize$.next();
    }
    onChangeLayoutSize(): Observable<any> {
        return this.layoutSize$.pipe(
            share(),
            delay(1),
        );
    }

    // Show Hide Header btn for Reservation
    changeShow(show: boolean) {
        this.headerBtn$.next(show);
    }

    // Show Total for Accounting
    updateTotal(value: number) {
        this.accountingTotal$.next(value);
    }


}